
(function() {
  'use strict';

  /* ══════════ FLAGS ══════════ */
  var DEBUG = false;                  // ← passe à true pour réactiver les logs de debug
  var ENABLE_SEARCH_FALLBACK = false; // ← fallback à 12 requêtes : désactivé (la section data suffit)

  function log() {
    if (DEBUG && window.console) console.log.apply(console, arguments);
  }

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). Le libelle
     de la forme (`shape.label`) vient du tag produit `forme:` : c'est une
     DONNEE, traduite par Shopify, pas une chaine d'interface. Seule la phrase
     qui l'entoure passe par une cle. */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  /* ══════════ 18/09/2026 · LES APPELS AJAX PARLENT LA LANGUE DE LA PAGE ═════
     C'est la regle maison du 06/09, ecrite pour `/cart.js` et jamais appliquee
     ici : un `fetch('/collections/all/...')` lance depuis une page /en, /de ou
     /nl est servi EN FRANCAIS. La section de donnees renvoyait donc
     `color:"Blanc"` quand le Liquid de la page avait pose `data-color="Weiss"`,
     aucune fiche soeur ne passait le test de coloris, la liste de formes sortait
     vide et le bloc se masquait. Les 8 gabarits Dywanopol et le fait main
     Carpet Decor etaient touches a l'identique, depuis toujours (§ 14.7).
     Prefixee par `Shopify.routes.root`, la meme URL rend les valeurs de
     metachamp dans la langue de la page, et les deux cotes se comparent.
     Les tags (`modele:`, `forme:`, tags de contexte) ne sont traduits par
     Shopify dans aucune locale : ils restent la cle sure, dans les deux sens. */
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (RACINE.charAt(RACINE.length - 1) !== '/') RACINE += '/';

  var container = document.getElementById('FormeSelector');
  if (!container) { log('[FormeSelector] ❌ Div introuvable'); return; }
  var optionsEl = document.getElementById('FormeOptions');

  /* ══════════ 17/09/2026 · LA RANGÉE COULEUR, ET SEULEMENT SUR DEMANDE ═════
     Les fiches fait main Carpet Decor n'ont pas le métachamp
     `custom.couleurs_associees` dont vit `color-siblings` : leurs coloris sont
     des fiches séparées reliées par le seul tag `modele:`. La rangée couleur
     se bâtit donc sur LA MÊME donnée que les formes, celle que rend
     `sections/forme-selector-data.liquid`, et pas sur une seconde source.

     TOUT CE QUI SUIT EST DERRIÈRE `data-colors="1"`, que seul le gabarit fait
     main pose. Sans cet attribut, le fichier se comporte exactement comme
     avant sur les huit gabarits Dywanopol : même filtrage, même cache, même
     rendu, même masquage.                                                   */
  var colorsEl = document.getElementById('FormeColors');
  var WANT_COLORS = container.getAttribute('data-colors') === '1' && !!colorsEl;

  var CFG = {
    model:   container.dataset.model   || '',
    color:   container.dataset.color   || '',
    shape:   container.dataset.shape   || '',
    context: container.dataset.context || '',
    handle:  container.dataset.handle  || ''
  };

  if (!CFG.model || !CFG.color || !CFG.shape || !CFG.context) {
    log('[FormeSelector] ❌ Config incomplète'); return;
  }

  var SHAPE_ORDER = ['Rectangle', 'Carré', 'Rond', 'Ovale', 'Couloir', 'Forme spéciale'];

  /* ══════════ CASEMIRA i18n R2c · LE DICTIONNAIRE SORT DU SCRIPT ══════════
     Ce fichier portait une table `CONTEXT_TAGS` qui redisait, en francais et
     en dur, la correspondance « contexte -> tags produit » que
     snippets/forme-selector.liquid etablit deja, en sens inverse, pour poser
     `data-context`. Deux copies de la meme regle dans deux langages : la
     seconde a modifier se serait oubliee.

     La liste vient maintenant de `data-context-tags`, posee par le Liquid a
     partir de la MEME table. Les valeurs restent des tags produit, que Shopify
     ne traduit dans aucune locale : c'est justement pourquoi ils servent de
     cle. Repli sur l'ancienne table si l'attribut manque (page servie par une
     version anterieure du snippet), jamais `undefined`. */
  var CONTEXT_TAGS_REPLI = {
    'Salon':     ['Tapis de Salon', 'Tapis de Couloir'],
    'Entree':    ["Tapis d'Entrée"],
    'Escalier':  ['Tapis Escalier'],
    'Cuisine':   ['Tapis de Cuisine'],
    'Exterieur': ["Tapis d'Extérieur"],
    'Enfant':    ['Tapis pour Enfant'],
    'Bain':      ['Tapis de Bain']
  };

  function tagsDuContexte() {
    var brut = container.getAttribute('data-context-tags');
    if (brut) {
      try {
        var liste = JSON.parse(brut);
        if (liste && liste.length) return liste;
      } catch (e) {}
    }
    return CONTEXT_TAGS_REPLI[CFG.context] || [];
  }

  /* Icônes uniformes 24×24 (système maquette) — rendu net et cohérent quel que
     soit le cadre, contrairement aux anciens viewBox hétérogènes. */
  var SHAPES_SVG = {
    'Rectangle': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="6" width="18" height="12" rx="1.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    'Carré': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="5" width="14" height="14" rx="1.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    'Rond': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"/></svg>',
    'Ovale': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><ellipse cx="12" cy="12" rx="9" ry="6.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    'Couloir': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><rect x="8.5" y="3" width="7" height="18" rx="1.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    /* Le catalogue compte un tag `forme:Forme spéciale` (tapis à contour
       découpé, ex. le Circo rectangulaire). Il sortait sans pictogramme, avec
       un cadre d'icône vide de 48×34 px. */
    'Forme spéciale': '<svg viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg"><path d="M4.6 9.6c1-3.3 4.3-5 7.8-4.4 3.2.6 5.9 2.7 6.1 5.6.2 3-2.3 5.2-5.2 6.1-3.2 1-6.8 1.1-8.4-1.1-1.3-1.8-1.1-4.2-.3-6.2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
  };

  /* ══════════ 18/09/2026 · LE LIBELLÉ DE LA FORME SE DIT DANS LA LANGUE ═════
     La CLÉ reste le tag `forme:` français : c'est lui qui trie (SHAPE_ORDER),
     qui choisit le pictogramme et qui désigne la tuile active. Seul le MOT
     affiché change. Sans cette table, le correctif de racine de langue aurait
     fait sortir « Rectangle », « Rond », « Couloir » en toutes lettres
     françaises sur une page allemande, exactement la crainte du § 14.7,
     point 3. Les cinq premières clés existaient déjà dans les quatre langues
     (`snippets/casemira-js-strings.liquid`) ; seule « Forme spéciale »
     manquait, elle a été ajoutée le 18/09.
     Repli code en français, jamais `undefined` : une valeur de tag hors de
     cette liste ressort telle quelle, comme avant. */
  function libelleForme(brut) {
    switch (brut) {
      case 'Rectangle':      return S.formeRectangle || brut;
      case 'Carré':          return S.formeCarre     || brut;
      case 'Rond':           return S.formeRond      || brut;
      case 'Ovale':          return S.formeOvale     || brut;
      case 'Couloir':        return S.formeCouloir   || brut;
      case 'Forme spéciale': return S.formeSpeciale  || brut;
      default:               return brut;
    }
  }

  /* Le cache de la rangée couleur dépend AUSSI de la forme regardée : deux
     fiches du même modèle et du même coloris mais de formes différentes n'ont
     pas la même liste de coloris. Préfixe distinct pour ne jamais relire un
     enregistrement `fs4_` (un tableau) comme un enregistrement v5 (un objet). */
  /* 18/09 : la RACINE entre dans la clé. Le coloris mis en cache est celui de
     la langue de la page (« Gris » en /fr, « Grau » en /de) : sans elle, un
     visiteur qui change de langue dans le même onglet relirait un
     enregistrement d'une autre locale et ne reconnaîtrait plus rien. */
  var CACHE_KEY = WANT_COLORS
    ? ('fs5c_' + RACINE + '|' + CFG.model + '|' + CFG.color + '|' + CFG.shape + '|' + CFG.context)
    : ('fs4_' + RACINE + '|' + CFG.model + '|' + CFG.color + '|' + CFG.context);
  var started = false; // garde-fou anti double-init

  /* ══════════ DÉCLENCHEUR DIFFÉRÉ ══════════ */
  /* Le travail (fetch + traitement) ne démarre QUE quand le bloc
     approche du viewport. Sur une fiche produit où l'utilisateur ne
     scrolle jamais jusqu'ici (ex : conversion directe Google Shopping),
     aucun fetch n'est jamais émis. */

  function start() {
    if (started) return;
    started = true;
    init();
  }

  function setupLazy() {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            start();
            break;
          }
        }
      }, { rootMargin: '1200px 0px' }); // anticipe largement avant l'arrivée
      io.observe(container);
    } else {
      // Vieux navigateur : on diffère quand même hors du chemin critique
      if ('requestIdleCallback' in window) {
        requestIdleCallback(start, { timeout: 3000 });
      } else {
        setTimeout(start, 1200);
      }
    }
  }

  /* ══════════ MAIN ══════════ */

  function init() {
    /* Cache */
    try {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        log('[FormeSelector] Cache trouvé');
        var lu = JSON.parse(cached);
        /* v4 gardait un TABLEAU de formes, v5 garde {s: formes, c: couleurs}.
           Les deux se relisent, et un enregistrement v4 vaut « pas de
           couleurs » : aucune purge de sessionStorage à prévoir. */
        if (lu && typeof lu.length === 'number') { render(lu, null); }
        else if (lu) { render(lu.s || [], lu.c || null); }
        return;
      }
    } catch(e) {}

    fetchViaCollectionTag();
  }

  /* ══════════ MÉTHODE : Collection tag filtering (1 seul appel) ══════════ */

  /* 18/09 · LE FILET. Jusqu'ici, un appel en échec (réseau coupé, 404, réponse
     illisible) sortait par un simple `return` avec le repli de recherche
     désactivé : les trois squelettes gris restaient à l'écran, figés, pour
     toujours. C'était le risque nommé au § 14.7 (« un correctif raté est plus
     visible que le défaut »). Tous les chemins d'échec passent désormais par
     ici, et la dégradation est celle d'un bloc sans sœur : hauteur 0, pas de
     titre orphelin, pas de squelette. */
  function masque() {
    container.style.display = 'none';
  }

  function fetchViaCollectionTag() {
    var tag = 'modele:' + CFG.model;
    var url = RACINE + 'collections/all/' + tag + '?section_id=forme-selector-data';

    log('[FormeSelector] 🔍 Fetch collection tag :', url);

    fetch(url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(text) {
        var trimmed = text.trim();
        var products;
        try {
          var jsonMatch = trimmed.match(/\[[\s\S]*\]/);
          if (!jsonMatch) throw new Error('Pas de JSON trouvé dans la réponse');
          products = JSON.parse(jsonMatch[0]);
        } catch(e) {
          log('[FormeSelector] ❌ JSON parse échoué');
          if (ENABLE_SEARCH_FALLBACK) { fetchViaSearch(); } else { masque(); }
          return;
        }

        log('[FormeSelector] ' + products.length + ' produit(s) trouvés via collection tag');
        processProducts(products);
      })
      .catch(function(err) {
        log('[FormeSelector] ⚠️ Collection tag échoué :', err.message);
        if (ENABLE_SEARCH_FALLBACK) { fetchViaSearch(); } else { masque(); }
      });
  }

  /* ══════════ FALLBACK : Search API (désactivé par défaut — coûteux) ══════════ */

  function fetchViaSearch() {
    var url = '/search/suggest.json?q=' + encodeURIComponent('modele:' + CFG.model)
            + '&resources[type]=product&resources[limit]=10';

    log('[FormeSelector] 🔍 Fetch search fallback :', url);

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var results = [];
        try { results = data.resources.results.products; } catch(e) {}
        var handles = results.map(function(p) { return p.handle; });

        if (!handles.length) { log('[FormeSelector] ❌ Aucun produit trouvé'); masque(); return; }

        return Promise.all(handles.map(function(h) {
          return fetch('/products/' + h + '.json')
            .then(function(r) { return r.json(); })
            .then(function(d) {
              var p = d.product;
              var shape = '';
              var tags = (p.tags || '').split(', ');
              tags.forEach(function(t) {
                if (t.indexOf('forme:') === 0) shape = t.split(':')[1];
              });
              return { handle: p.handle, url: '/products/' + p.handle, model: '', color: '', shape: shape, tags: tags };
            })
            .catch(function() { return null; });
        })).then(function(products) {
          products = products.filter(Boolean);
          processProductsLoose(products);
        });
      })
      .catch(function(err) { log('[FormeSelector] ❌ Search fallback échoué :', err); masque(); });
  }

  /* ══════════ TRAITEMENT ══════════ */

  /* Deux fiches d'un même modèle peuvent porter LE MÊME `couleur_principale`
     et être pourtant deux coloris distincts : l'Arcadia « Gris Clair » et
     l'Arcadia « Gris Acier » valent tous deux « Gris ». Quand deux fiches se
     disputent la même forme, on garde donc celle dont le handle ressemble le
     plus à celui qu'on regarde. Départage seulement : sans signal, la
     première gagne, comme avant. */
  function proximite(a, b) {
    var A = String(a || '').split('-'), B = String(b || '').split('-'), n = 0, i;
    for (i = 0; i < A.length; i++) {
      if (A[i] && B.indexOf(A[i]) !== -1) n++;
    }
    return n;
  }

  function processProducts(products) {
    var contextTags = tagsDuContexte();
    var shapesMap = {};
    var colors = WANT_COLORS ? [] : null;

    products.forEach(function(p) {
      if (p.model !== CFG.model) return;

      var tags = p.tags || [];
      /* Liste de contexte VIDE = pas de critère de contexte. C'est le cas des
         fiches fait main, qui n'ont aucun des sept tags `Tapis de …`. Sur une
         fiche Dywanopol la liste n'est jamais vide : le test ci-dessous est
         alors exactement celui d'avant. */
      if (contextTags.length) {
        var hasContext = false;
        for (var i = 0; i < tags.length; i++) {
          if (contextTags.indexOf(tags[i]) !== -1) { hasContext = true; break; }
        }
        if (!hasContext) return;
      }

      var shape = p.shape || '';

      /* La rangée COULEUR : une fiche par coloris, à forme égale. */
      if (colors && shape === CFG.shape) {
        colors.push({ label: p.color || '', url: p.url, img: p.img || '', handle: p.handle });
      }

      /* La rangée FORME : à coloris égal, comme depuis toujours. */
      if (p.color !== CFG.color) return;
      if (!shape) return;

      if (!shapesMap[shape]) {
        shapesMap[shape] = { label: shape, url: p.url, score: proximite(CFG.handle, p.handle) };
      } else if (WANT_COLORS) {
        var s = proximite(CFG.handle, p.handle);
        if (s > shapesMap[shape].score) {
          shapesMap[shape] = { label: shape, url: p.url, score: s };
        }
      }
      log('[FormeSelector]   ✓ ' + p.handle + ' → ' + shape);
    });

    var sorted = sortShapes(shapesMap);
    cacheAndRender(sorted, colors);
  }

  function processProductsLoose(products) {
    var contextTags = tagsDuContexte();
    var shapesMap = {};

    products.forEach(function(p) {
      var tags = p.tags || [];
      var hasContext = false;
      for (var i = 0; i < tags.length; i++) {
        if (contextTags.indexOf(tags[i]) !== -1) { hasContext = true; break; }
      }
      if (!hasContext) return;
      if (!p.shape) return;
      if (!shapesMap[p.shape]) shapesMap[p.shape] = { label: p.shape, url: p.url };
    });

    var sorted = sortShapes(shapesMap);
    cacheAndRender(sorted, null);
  }

  function sortShapes(shapesMap) {
    var sorted = [];
    SHAPE_ORDER.forEach(function(s) { if (shapesMap[s]) sorted.push(shapesMap[s]); });
    Object.keys(shapesMap).forEach(function(s) {
      if (SHAPE_ORDER.indexOf(s) === -1) sorted.push(shapesMap[s]);
    });
    return sorted;
  }

  function cacheAndRender(shapes, colors) {
    log('[FormeSelector] Résultat final : ' + shapes.length + ' forme(s)'
        + (colors ? ', ' + colors.length + ' coloris' : ''));
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(WANT_COLORS ? { s: shapes, c: colors } : shapes));
    } catch(e) {}
    render(shapes, colors);
  }

  /* ══════════ RENDER (sans reflow en boucle) ══════════ */

  function echappe(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function render(shapes, colors) {
    var aFormes = !!(shapes && shapes.length > 1);
    var aCouleurs = !!(WANT_COLORS && colors && colors.length > 1);

    if (!aFormes && !aCouleurs) {
      // Rien de pertinent à proposer → on masque le bloc (et son skeleton)
      container.style.display = 'none';
      return;
    }

    /* La rangée des formes. `optionsEl.parentNode` est le
       `.forme-selector__inner` qui porte son titre : une rangée sans contenu
       se masque AVEC son titre, jamais un libellé orphelin. */
    if (aFormes) {
      var frag = document.createDocumentFragment();
      shapes.forEach(function(shape, i) {
        var isActive = (shape.label === CFG.shape);
        /* `shape.label` reste la CLÉ (tri, pictogramme, tuile active) ;
           `libelle` est le mot que lit le visiteur, dans sa langue. */
        var libelle = libelleForme(shape.label);
        var el = document.createElement(isActive ? 'span' : 'a');
        el.className = 'forme-option' + (isActive ? ' forme-option--active' : '');
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', isActive ? 'true' : 'false');
        el.setAttribute('aria-label', libelle);
        el.setAttribute('data-enter', '');
        el.style.animationDelay = (i * 50) + 'ms';
        if (!isActive) {
          el.href = shape.url;
          el.title = avec(S.formeVoirEn || 'Voir en [forme]', '[forme]', libelle);
        }
        el.innerHTML = '<span class="forme-option__icon">' + (SHAPES_SVG[shape.label] || '') + '</span>'
                     + '<span class="forme-option__label">' + echappe(libelle) + '</span>';
        frag.appendChild(el);
      });

      optionsEl.innerHTML = '';   // retire les skeletons
      optionsEl.appendChild(frag);
    } else if (optionsEl && optionsEl.parentNode) {
      optionsEl.parentNode.hidden = true;
    }

    /* La rangée des coloris : une vignette par fiche sœur de même forme. */
    if (aCouleurs) {
      var fragC = document.createDocumentFragment();
      colors.forEach(function(c, i) {
        var isActive = (c.handle === CFG.handle);
        var el = document.createElement(isActive ? 'span' : 'a');
        el.className = 'forme-couleur' + (isActive ? ' forme-couleur--active' : '');
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', isActive ? 'true' : 'false');
        el.setAttribute('aria-label', c.label || '');
        el.setAttribute('data-enter', '');
        el.style.animationDelay = (i * 50) + 'ms';
        if (!isActive) { el.href = c.url; el.title = c.label || ''; }
        el.innerHTML = c.img
          ? '<img src="' + echappe(c.img) + '" alt="' + echappe(c.label) + '" loading="lazy" width="64" height="64">'
          : '<span class="forme-couleur__nom">' + echappe(c.label) + '</span>';
        fragC.appendChild(el);
      });
      colorsEl.innerHTML = '';
      colorsEl.appendChild(fragC);
      if (colorsEl.parentNode) colorsEl.parentNode.hidden = false;
    } else if (WANT_COLORS && colorsEl && colorsEl.parentNode) {
      colorsEl.parentNode.hidden = true;
    }

    container.style.display = ''; // au cas où il aurait été masqué précédemment
  }

  /* ── GO (différé) ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupLazy);
  } else {
    setupLazy();
  }
})();
